const round = value => Math.round((Number(value) || 0) * 100) / 100;

const summarizeFinanceReportRows = rows => {
  const items = Array.isArray(rows) ? rows : [];
  const fundingTotals = { CRF: 0, EI: 0 };
  const categoryTotals = {
    tuition: 0,
    booksMaterials: 0,
    living: 0,
    childcare: 0,
    wage: 0,
    other: 0,
  };
  const participantKeys = new Set();
  const interventionKeys = new Set();
  const provinceCodes = new Set();
  const provinceSummary = new Map();

  items.forEach(row => {
    const totalAmount = Number(row?.totalAmount || 0);
    if (row?.fundingSource === "CRF") {
      fundingTotals.CRF += totalAmount;
    } else if (row?.fundingSource === "EI") {
      fundingTotals.EI += totalAmount;
    }
    categoryTotals.tuition += Number(row?.tuitionAmount || 0);
    categoryTotals.booksMaterials += Number(row?.booksMaterialsAmount || 0);
    categoryTotals.living += Number(row?.livingAmount || 0);
    categoryTotals.childcare += Number(row?.childcareAmount || 0);
    categoryTotals.wage += Number(row?.wageAmount || 0);
    categoryTotals.other += Number(row?.otherAmount || 0);

    const interventionKey = row.reportingInterventionKey || row.id;
    interventionKeys.add(interventionKey);
    if (row?.participantKey && totalAmount > 0) {
      participantKeys.add(String(row.participantKey));
    }
    if (row?.participantProvince) {
      provinceCodes.add(row.participantProvince);
    }

    const provinceKey = row?.participantProvince || "UNSPECIFIED";
    if (!provinceSummary.has(provinceKey)) {
      provinceSummary.set(provinceKey, {
        provinceCode: row?.participantProvince || null,
        provinceName: row?.participantProvinceName || "Unspecified",
        crfAmount: 0,
        eiAmount: 0,
        totalAmount: 0,
        interventionKeys: new Set(),
        participants: new Set(),
      });
    }
    const provinceEntry = provinceSummary.get(provinceKey);
    provinceEntry.totalAmount += totalAmount;
    provinceEntry.interventionKeys.add(interventionKey);
    if (row?.fundingSource === "CRF") {
      provinceEntry.crfAmount += totalAmount;
    } else if (row?.fundingSource === "EI") {
      provinceEntry.eiAmount += totalAmount;
    }
    if (row?.participantKey && totalAmount > 0) {
      provinceEntry.participants.add(String(row.participantKey));
    }
  });

  return {
    totalAmount: round(items.reduce((sum, row) => sum + Number(row?.totalAmount || 0), 0)),
    fundingTotals: Object.fromEntries(Object.entries(fundingTotals).map(([key, value]) => [key, round(value)])),
    categoryTotals: Object.fromEntries(Object.entries(categoryTotals).map(([key, value]) => [key, round(value)])),
    carryOver: { enabled: false },
    interventionCount: interventionKeys.size,
    participantCount: participantKeys.size,
    provinceCount: provinceCodes.size,
    provinceRows: Array.from(provinceSummary.values())
      .map(entry => ({
        provinceCode: entry.provinceCode,
        provinceName: entry.provinceName,
        crfAmount: round(entry.crfAmount),
        eiAmount: round(entry.eiAmount),
        totalAmount: round(entry.totalAmount),
        interventionCount: entry.interventionKeys.size,
        participantCount: entry.participants.size,
      }))
      .sort((left, right) =>
        String(left?.provinceName || "Unspecified").localeCompare(
          String(right?.provinceName || "Unspecified")
        )
      ),
  };
};

module.exports = { summarizeFinanceReportRows };
